import { PropsWithChildren } from 'react'
import { ArticleView, LayerPermissions } from 'types'
import { observer } from 'mobx-react-lite'
import { ArticleViewContext } from 'providers/ArticleViewProvider/ArticleViewProvider'

interface Props {
  targetArticleView: ArticleView
  permissions: Pick<LayerPermissions, 'can_edit_content' | 'can_comment'>
}

export const PermittedArticleViewProvider = observer(function PermittedViewProvider({
  children,
  targetArticleView,
  permissions,
}: PropsWithChildren<Props>) {
  const { can_edit_content: canEdit, can_comment: canComment } = permissions

  let permittedArticleView = targetArticleView

  // check permissions
  if (permittedArticleView === ArticleView.Editing && !canEdit) {
    permittedArticleView = ArticleView.Commenting
  }

  if (permittedArticleView === ArticleView.Commenting && !canComment) {
    permittedArticleView = ArticleView.Reading
  }

  return (
    <ArticleViewContext.Provider value={{ articleView: permittedArticleView }}>{children}</ArticleViewContext.Provider>
  )
})
